// import { StudentData } from '../../util/types';

import splitStudentsFromFormData from './splitStudentsFromFormData';

// export function addBlankStudent(state: any, payload: any) {
//   const data: StudentData = {
//     firstName: '',
//     lastName: '',
//   };

//   const students = state.students?.length ? state.students : [];
//   students.push(data);

//   return {
//     ...state,
//     students: students,
//     // formData should come in merged from ...state (we're just updating students here)
//     // formData: mergedFormData,
//   };


// };

// Merge payload with current state
export function updateAction(state: any, payload: any) {
  // TODO: format student info into separate object/array?
  // Wait, idk if that will work - if it will propagate to the components/props correctly...

  // Take current existing state and remove all students, and store them separately
  // Ignore students from state and replace with payload
  // const [filteredStateFormData, studentsStateFormData] = splitStudentsFromFormData(state.formData);
  const [filteredPayloadFormData, studentsPayloadFormData] = splitStudentsFromFormData(payload.formData);

  // Merge the data coming in because each step has its own formData
  // If I don't save the students in formData, it won't ever have them in state...
  const mergedFormData = {
    ...state.formData,
    ...filteredPayloadFormData,
  };

  const mergedFileFields = {
    ...state.files,
    ...payload.files,
  };

  // If we do have files
  // if (payload.files && Object.keys(payload.files).length) {

  // console.log(state, payload);

  const newState = {
    ...state,
    // If step doesn't have students, keep from existing state
    students: studentsPayloadFormData.length ? studentsPayloadFormData : state.students,
    formData: mergedFormData,
    files: mergedFileFields,
  };

  return newState;
}

// Replace student info only
// export function updateStudentInfoAction(state: any, payload: any) {


//   console.log('cleaning state', state);
//   // Delete any fields starting with 'student_x_'
//   // then merge payload
//   const stateWithoutStudentInfo = Object.entries(state).reduce((accum: any, [fieldName, fieldValue]) => {
//     // const isStudentField = STUDENT_REGEX.test(fieldName);
//     // if (!isStudentField) accum[fieldName] = fieldValue;

//     const result = STUDENT_REGEX.exec(fieldName);
//     const student_index = parseInt(result?.[1] as string);
//     console.log(student_index);
//     if (isNaN(student_index)) accum[fieldName] = fieldValue;
//     return accum;
//   }, {});

//   console.log(stateWithoutStudentInfo, payload);

//   return {
//     ...stateWithoutStudentInfo,
//     ...payload.formData,
//   };
// }

// Replace state with payload
export function replaceAction(state: any, payload: any) {
  // console.log(state, payload);
  return payload;
}

// Clear data
export function clearAction(state: any, payload: any) {
  return {
    data: {}
  };
}
